import React from "react";

export default function ConfirmMemberModal({
    open,
    member,
    book,
    onClose = () => { },
    onContinue = () => { },
}) {
    if (!open) return null;

    const memberName = member?.name || "-";
    const memberId = member?.memberId || member?.id || "-";
    const phone = member?.phone || "-";
    const email = member?.email || "-";
    const address = member?.address || "-";

    const bookTitle = book?.title || "-";
    const bookId = book?.id || "-";
    const bookImg = book?.img || "https://via.placeholder.com/80x110";
    const credits = book?.credits ?? "-";

    const stock = book?.stock_status || "Available";
    const isOut = stock === "outofstock";

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
            <div className="w-full max-w-3xl rounded-xl bg-white shadow-lg overflow-hidden">
                {/* Header */}
                <div className="px-8 pt-8 pb-4">
                    <h2 className="text-3xl font-semibold text-gray-900">
                        Confirm Member
                    </h2>
                    <p className="text-gray-500 mt-1">
                        The book is associated with the member bellow
                    </p>
                </div>

                {/* Body */}
                <div className="px-8 pb-6 space-y-5">
                    {/* Book Card */}
                    <div className="border rounded-xl p-4 flex items-center gap-4 bg-white">
                        <div className="w-16 h-24 rounded-lg overflow-hidden border flex-shrink-0">
                            <img
                                src={bookImg}
                                alt={bookTitle}
                                className="w-full h-full object-cover"
                            />
                        </div>

                        <div className="flex-1 min-w-0">
                            <p className="font-semibold text-gray-900 truncate">
                                {bookTitle}
                            </p>

                            <p className="text-sm text-blue-600 mt-1">
                                {credits !== "-" ? `${credits} Credit` : "—"}
                            </p>

                            <p
                                className={`text-sm font-medium mt-1 ${isOut ? "text-red-500" : "text-green-600"
                                    }`}
                            >
                                {isOut ? "Out of stock" : "Available"}
                            </p>

                            <p className="text-xs text-gray-400 mt-1">ID: {bookId}</p>
                        </div>
                    </div>

                    {/* Member Box */}
                    <div className="border rounded-xl p-5 bg-white">
                        <div className="flex justify-between items-start gap-6">
                            <div>
                                <p className="text-sm font-semibold text-gray-900">
                                    Member Name:{" "}
                                    <span className="font-normal text-gray-700">
                                        {memberName}
                                    </span>
                                </p>

                                <p className="text-xs text-gray-500 mt-1">Phone No: {phone}</p>
                                <p className="text-xs text-gray-500 mt-1">Email Id: {email}</p>

                                <p className="text-xs text-gray-400 mt-1">
                                    Address: {address}
                                </p>
                            </div>

                            <div className="text-sm font-semibold text-gray-900">
                                Member Id: {memberId}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Buttons */}
                <div className="px-8 pb-8 flex justify-center gap-4">
                    <button
                        onClick={onClose}
                        className="px-10 py-2 rounded-md border text-gray-700 hover:bg-gray-50"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={onContinue}
                        disabled={isOut}
                        className={`px-10 py-2 rounded-md font-semibold text-white transition-all ${isOut
                            ? "bg-gray-300 cursor-not-allowed"
                            : "bg-black hover:bg-gray-800"
                            }`}
                    >
                        {isOut ? "Out of Stock" : "Continue"}
                    </button>
                </div>
            </div>
        </div>
    );
}
